module.exports = "/static/assets/ad218339ca42519f314d17dba03dff83.png";